import { render, staticRenderFns } from "./MensageriaInterna.vue?vue&type=template&id=df4e978c&scoped=true"
import script from "./MensageriaInterna.vue?vue&type=script&lang=js"
export * from "./MensageriaInterna.vue?vue&type=script&lang=js"
import style0 from "./MensageriaInterna.vue?vue&type=style&index=0&id=df4e978c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4e978c",
  null
  
)

export default component.exports